<template>
  <v-dialog v-model="value" width="600" persistent>
    <v-card>
      <v-card-title class="idcs-dialog-title">
        <span>{{$t("dialog.newtask")}}</span>
        <v-spacer></v-spacer>
        <v-btn @click="$emit('input',false)" icon color="error">
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div class="text-right">
          <span class="mr-2">{{$t("fields.sender")}}</span>
          <span class="subtitle-2">{{$store.getters['user/sender']}}</span>
        </div>
        <v-form lazy-validation ref="form">
          <v-text-field
            v-model="name"
            :label="$t('fields.name')+'*'"
            :rules="[v => !!v || $t('error.required')]"
          ></v-text-field>
          <v-select v-model="type" :items="$t('task_types')"></v-select>
          <v-select v-model="template" :items="templates" :label="$t('fields.template')"></v-select>
          <v-select
            v-model="list"
            :items="lists"
            item-text="name"
            return-object
            :label="$t('fields.list')+'*'"
            :rules="[v=>!!v||$t('error.required')]"
          ></v-select>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="create" :disabled="isPressed" color="blue" text>{{$t("button.update")}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from "@/api.js";
export default {
  name: "NewTaskDialog",
  props: {
    value: { type: Boolean }
  },
  data() {
    return {
      isPressed: false,
      type: 0,
      name: "",
      template: "",
      list: {}
    };
  },
  computed: {
    lists() {
      return this.$store.getters["data/lists"];
    },
    templates() {
      return this.$store.getters["data/templates"];
    }
  },
  methods: {
    create() {
      if (!this.$refs.form.validate()) return;
      this.isPressed = true;
      api
        .createTask({
          list: this.list.name,
          type_: this.type,
          name_: this.name,
          message_tpl: this.template?this.template:'',
          recipients: this.list.members
        })
        .then(response => {
          this.isPressed = false;
          if (response) this.$router.push("/task/" + response);
        });
    }
  },
  mounted() {
    if (!this.$store.getters["data/isTemplates"]) {
      this.$store.dispatch("data/LOAD_TEMPLATES").then(() => {
        this.template = this.templates[0];
      });
    }
    if (!this.$store.getters["data/isLists"]) {
      this.$store.dispatch("data/LOAD_LISTS").then(() => {
        this.list = this.lists[0];
      });
    }
  }
};
</script>

<style>
</style>